import React, { Component } from 'react';
import BoxLogTable from './BoxLogTable';
class LogsDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sort: {
        name: '',
        order: '',
      },
    };
  }
  render() {
    const { boxLogs } = this.props;
    const { sort } = this.state;
    const renderList = sort.name.length
      ? boxLogs?.length && this.sortColumnByKey(boxLogs)
      : boxLogs;
    return (
      <div className="viewContainer" style={{ marginTop: '20px' }}>
        <BoxLogTable boxesList={renderList} />
      </div>
    );
  }
}

export default LogsDetails;
